import React, {FC} from 'react';

import {KeyboardActionsEnum} from '../../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {UnreachableError} from '../../../../../libs/shared/helpers/src/types/customErrors';
import {KeyboardShortcuts} from '../../../../../libs/shared/ui/src/components/keyboard/keyboardShortcuts';
import {UndoBannerState, UndoBannerTypesEnum} from '../../../../store/panels/app/banners/bannersState';
import {AppPanelId} from '../../../../store/panels/panelStateBase';
import {AccountDetailsUndoBannerContainer} from './accountDetailsUndoBannerContainer';
import {ContactDetailsUndoBannerContainer} from './contactDetailsUndoBannerContainer';
import {ConversationUndoBannerContainer} from './conversationUndoBannerContainer';
import {MessageUndoBannerContainer} from './messageUndoBannerContainer';

/*
 * Props.
 */

interface UndoBannersProps {
  panelId: AppPanelId;
  banners: ReadonlyArray<UndoBannerState>;
  onUndoLastBannerClick: Handler;
}

/*
 * Component.
 */

export const UndoBanners: FC<UndoBannersProps> = (props) => {
  const keyHandlers = {
    [KeyboardActionsEnum.UNDO]: props.onUndoLastBannerClick,
  };

  return (
    <KeyboardShortcuts handlers={keyHandlers}>
      {props.banners.map((b) => renderUndoBanner(props.panelId, b))}
    </KeyboardShortcuts>
  );
};

function renderUndoBanner(panelId: AppPanelId, banner: UndoBannerState) {
  switch (banner.undoType) {
    case UndoBannerTypesEnum.CONVERSATION:
      return <ConversationUndoBannerContainer key={`undo-${banner.uid}`} panelId={panelId} state={banner} />;

    case UndoBannerTypesEnum.MESSAGE:
      return <MessageUndoBannerContainer key={`undo-${banner.uid}`} panelId={panelId} state={banner} />;

    case UndoBannerTypesEnum.CONTACT_DETAILS:
      return (
        <ContactDetailsUndoBannerContainer key={`undo-${banner.uid}`} panelId={panelId} state={banner} />
      );

    case UndoBannerTypesEnum.ACCOUNT_DETAILS:
      return (
        <AccountDetailsUndoBannerContainer key={`undo-${banner.uid}`} panelId={panelId} state={banner} />
      );

    default:
      throw new UnreachableError(banner);
  }
}
